/* Spanish catalog mirroring locale-fr-part3.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'set.import.packages.statusUploaded': 'Subido',
  'set.import.packages.uploadedAt': 'Subido el {date}',
  'set.import.packages.readAt': 'Última lectura el {date}',
  'set.import.packages.importedAt': 'Importado a la contabilidad el {date}',
  'set.import.packages.notAvailable': 'Hora desconocida',
  'set.import.packages.unknownSize': 'Tamaño desconocido',
  'set.import.packages.deleteConfirm': '¿Eliminar {name}? El archivo ZIP y los datos temporales de análisis se eliminarán de forma permanente. No se importó ningún dato contable de este paquete.',
  'set.import.packages.deletePreviousConfirm': '¿Eliminar el paquete de importación anterior {name}? Los datos contables importados se conservarán. Los documentos que solo están en este ZIP antiguo no se podrán abrir después de eliminarlo.',
  'set.import.packages.deleteDialogTitle': '¿Eliminar el paquete de importación?',
  'set.import.packages.deleteDialogBody': 'Estás a punto de eliminar {name}. El archivo ZIP y sus datos de análisis se eliminarán de forma permanente del backend.',
  'set.import.packages.deletePreviousBody': 'Estás a punto de eliminar el paquete de importación anterior {name}. Los datos contables se conservarán, pero los documentos que solo están en este ZIP no se podrán abrir después.',
  'set.import.packages.deleteIrreversible': 'Esta acción no se puede deshacer.',
  'set.import.packages.replaceTitle': '¿Reemplazar el paquete de importación existente?',
  'set.import.packages.replaceBody': 'Ya tienes el paquete de importación {name}. Cuando el nuevo paquete se analice y se apruebe, pasará a ser el activo y todos los paquetes ZIP anteriores se eliminarán del backend.',
  'set.import.packages.replaceSafety': 'El paquete existente se conserva mientras se sube y se analiza el nuevo. Si el análisis falla o se cancela, el paquete activo actual queda intacto.',
  'set.import.packages.replacePermanent': 'Tras la aprobación, la eliminación del paquete antiguo no se puede deshacer.',
  'set.import.packages.chooseReplacement': 'Elegir nuevo ZIP',
  'set.import.packages.deleteProtected': 'Este paquete lo usa la contabilidad y no se puede eliminar aquí.',
  'set.import.packages.protectedHelp': 'Es la fuente activa de los documentos de justificantes importados y no se puede eliminar.',
  'set.import.packages.duplicateHelp': 'El contenido del archivo es idéntico al del paquete de importación activo y se puede eliminar.',
  'set.import.packages.deleting': 'Eliminando...',
  'set.import.packages.delete': 'Eliminar',
  'set.import.packages.deleted': 'El paquete de importación se eliminó.',
  'set.import.packages.deleteFailed': 'No se pudo eliminar el paquete de importación.',
  'set.import.packages.deleteMissing': 'Falta la ruta de almacenamiento del paquete de importación.',
  'set.import.packages.download': 'Descargar ZIP',
  'set.import.packages.downloading': 'Preparando...',
  'set.import.packages.downloadMissing': 'Falta la ruta de almacenamiento del paquete de importación.',
  'set.import.packages.downloadStarted': 'Ha comenzado la descarga del ZIP original.',
  'set.import.packages.downloadFailed': 'No se pudo descargar el paquete de importación.',
  'set.import.years.title': 'Elegir años de datos',
  'set.import.years.help': 'Solo se importan las cifras y los datos de los años seleccionados. Los registros y el archivo de documentos se tratan por separado.',
  'set.import.years.recommended': 'Periodo recomendado',
  'set.import.years.previousOnly': 'Solo años anteriores',
  'set.import.years.all': 'Todos los años',
  'set.import.years.current': 'año en curso',
  'set.import.years.retentionWarning': 'Has excluido {years}, que aún pueden estar dentro del periodo normal de conservación. Asegúrate de conservar ese material en otro lugar.',
  'set.import.years.documentsPreserved': 'El ZIP original y el archivo de documentos se conservan completos, sea cual sea la selección de años.',
  'set.import.years.importedTitle': 'Años de datos importados',
  'set.import.years.importedHelp': 'Elimina las cifras importadas de un año sin eliminar el ZIP, el archivo de documentos ni los registros creados manualmente.',
  'set.import.years.removeYear': 'Eliminar datos importados de {year}',
  'set.import.years.removeTitle': '¿Eliminar los datos importados de {year}?',
  'set.import.years.removeBody': 'Se eliminarán el balance de apertura importado, el historial de informes, las partidas abiertas propias del año y los estados de cumplimiento importados de {year}.',
  'set.import.years.removePreserves': 'Se conservan las facturas manuales, las compras, los justificantes, los registros, el ZIP original y el archivo de documentos.',
  'set.import.years.removeConfirm': 'Eliminar datos',
  'set.import.years.removing': 'Eliminando...',
  'set.import.years.removed': 'Se eliminaron {count} datos importados de {year}.',
  'set.import.years.removeFailed': 'No se pudieron eliminar los datos importados del año.',
  'set.import.years.invalid': 'Elige un año de importación válido.',
  'set.import.years.selectedLedgerRows': 'filas de historial en los años seleccionados',
  'set.showAll': 'Mostrar todo',
  'set.count.accounts': 'cuentas de balance',
  'set.count.customers': 'clientes',
  'set.count.products': 'productos',
  'set.count.openSalesInvoices': 'facturas de cliente abiertas',
  'set.count.openPurchaseInvoices': 'facturas de proveedor abiertas',
  'set.count.suppliers': 'proveedores',
  'set.count.openingBalances': 'saldos de apertura',
  'set.import.after': 'Después de la importación',
  'set.noMatches': 'Sin coincidencias.',
  'set.preview': 'Vista previa',
  'set.previewHeading': 'Así se ve el documento',
  'set.preview.sender': 'Remitente:',
  'set.preview.invoiceNo': 'N.º de factura:',
  'set.preview.invoiceDate': 'Fecha de factura:',
  'set.preview.dueDate': 'Fecha de vencimiento:',
  'set.preview.accountNo': 'N.º de cuenta:',
  'set.preview.toPay': 'A pagar:',
  'set.preview.docType': 'FACTURA',
  'set.preview.noCustomer': 'Aún no se ha seleccionado ningún cliente',
  'set.preview.net': 'Neto',
  'set.preview.vat': 'IVA',
  'set.preview.toPayShort': 'A pagar',
  'set.menu.title': 'Menú lateral',
  'set.menu.help': 'Elige qué páginas aparecen en el menú de la izquierda. Las páginas principales siempre están visibles.',
  'set.menu.showAll': 'Mostrar todas las páginas',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Importar',
  'set.data.accountingTitle': 'Importación / exportación de la contabilidad',
  'set.data.accountingSub': 'Importa desde otro sistema contable con archivos ZIP, SAF-T, CSV o Excel, y exporta una copia de seguridad y resúmenes de la contabilidad.',
  'set.export': 'Exportar',
  'set.data.invoiceCsv': 'CSV de facturas',
  'set.data.invoiceTemplate': 'Plantilla de importación de facturas',
  'set.data.bookkeepingCsv': 'CSV de contabilidad',
  'set.data.reusePackage': 'Reutiliza el archivo de exportación subido, sin una nueva subida.',
  'set.data.resetAll': 'Restablecer todos los datos',
  'set.data.deleteBusiness': 'Eliminar empresa',
  'set.data.onlyOwnerSchedule': 'Solo el propietario puede programar la eliminación.',
  'set.doc.tab': 'Documentos',
  'svc.mcpMissingRedirect': 'El servicio MCP no devolvió una redirección segura.',
  'route.dailySettlements': 'Cierres diarios',
  'nav.dailySettlements': 'Cierres diarios',
  'navhelp.dailySettlements': 'Cierres diarios de sistemas de punto de venta, reservas, alquiler y tiendas en línea. Revisa y aprueba antes de contabilizar.',
  'dailySettlement.title': 'Cierres diarios',
  'dailySettlement.sub': 'Cierres de punto de venta, reservas, alquiler y tiendas en línea. No se contabiliza nada hasta que lo apruebes.',
  'dailySettlement.refresh': 'Actualizar',
  'dailySettlement.loadError': 'No se pudieron cargar los cierres diarios.',
  'dailySettlement.openSettings': 'Abrir integraciones',
  'dailySettlement.emptyTitle': 'No hay cierres diarios aquí',
  'dailySettlement.emptyText': 'Cuando una fuente esté conectada y haya enviado un cierre, aparecerá aquí para su revisión y aprobación.',
  'dailySettlement.filter.open': 'Por gestionar',
  'dailySettlement.filter.ready': 'Listo',
  'dailySettlement.filter.review': 'Requiere revisión',
  'dailySettlement.filter.done': 'Terminado',
  'dailySettlement.status.ready': 'Listo para aprobar',
  'dailySettlement.status.review': 'Requiere revisión',
  'dailySettlement.status.approved': 'Contabilizado',
  'dailySettlement.status.dismissed': 'Cerrado sin contabilizar',
  'dailySettlement.attentionTitle': 'Fuentes que requieren atención',
  'dailySettlement.attentionStale': '{provider} no ha enviado ningún cierre en {days} días. El último fue el {date}.',
  'dailySettlement.attentionNever': '{provider} está conectado, pero nunca ha enviado un cierre.',
  'dailySettlement.homeWaiting': '{ready} listos para aprobar, {review} requieren revisión.',
  'dailySettlement.homeAction': 'Abrir cierres diarios',
  'set.doc.title': 'Documentos',
  'set.doc.sub': 'Sube y guarda tus propios documentos, por ejemplo contratos, seguros o estatutos.',
  'set.doc.drop': 'Arrastra los archivos aquí',
  'set.doc.dropHint': 'O haz clic para elegir un archivo',
  'set.doc.empty': 'Aún no se ha subido ningún documento.',
  'set.doc.added': 'Añadido',
  'set.doc.new': 'Nuevo documento',
  'set.doc.edit': 'Editar documento',
  'set.doc.remove': 'Quitar documento',
  'set.doc.open': 'Abrir documento',
  'set.doc.add': 'Añadir documento',
  'set.doc.name': 'Nombre',
  'set.doc.namePh': 'Por ejemplo, Seguro de responsabilidad civil 2026',
  'set.doc.nameRequired': 'Primero ponle un nombre al documento',
  'set.doc.type': 'Tipo',
  'set.doc.attachTo': 'Adjunto por defecto a',
  'set.doc.attachToHint': 'El documento se incluye automáticamente con estos tipos de documento: se puede quitar en cada envío.',
  'set.doc.uploading': 'Subiendo...',
  'set.doc.uploaded': 'Documento subido',
  'set.doc.saved': 'Documento actualizado',
  'set.doc.deleted': 'Documento quitado',
  'set.doc.deleteConfirm': '¿Eliminar el documento "{name}"?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG o WEBP. Máx. 10 MB.',
  'set.doc.unavailable': 'La página de documentos no se cargó. Recarga la página: si sigue vacía, es un error que debemos revisar.',
  'set.doc.target.offer': 'Presupuestos',
  'set.doc.target.orderConfirmation': 'Confirmaciones de pedido',
  'set.doc.target.invoice': 'Facturas',
  'set.doc.target.creditNote': 'Notas de crédito',
  'set.doc.target.subscription': 'Suscripciones y listas',
  'set.doc.target.subscriptionHint': 'Se incluye en los correos que envías desde una suscripción o una lista de clientes.',
  'set.doc.kind.agreement': 'Contrato',
  'set.doc.kind.insurance': 'Seguro',
  'set.doc.kind.articles': 'Estatutos',
  'set.doc.kind.authorization': 'Poder notarial',
  'set.doc.kind.certificate': 'Certificado',
  'set.doc.kind.standard_attachment': 'Adjunto estándar',
  'set.doc.kind.other': 'Otro',
  'sale.att.standard': 'Estándar',
  'sale.att.removeStandard': 'No incluir esta vez',
  'sale.att.remove': 'Quitar adjunto',
  'sub.standardDocs': 'Documentos estándar incluidos: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Configuración contable',
  'set.acc.sub': 'Ajustes básicos de la contabilidad: primer ejercicio fiscal, alta en el IVA, método contable y similares.',
  'set.acc.startYear': 'Año de inicio',
  'set.acc.startYearHelp': 'El primer ejercicio fiscal que llevas en Plumme. Los justificantes e informes anteriores a este año pertenecen a un sistema anterior.',
  'set.acc.startInvoiceNo': 'Número de factura inicial',
  'set.acc.startInvoiceNoHelp': 'El número que recibirá tu primera factura. Si vienes de otro sistema, indica un número mayor que el último usado para tener una numeración ininterrumpida (un requisito legal).',
  'set.acc.vatStatus': 'Situación de IVA',
  'set.acc.vatStatusHelp': 'Indica si la empresa está dada de alta en el registro de IVA. Pasas a estar obligado a aplicar IVA cuando la facturación sujeta supera 50 000 NOK en 12 meses. Estar dado de alta en el IVA significa que cobras IVA en las ventas y lo deduces en las compras.',
  'set.acc.vatRegistered': 'Alta en el IVA',
  'set.acc.notVatRegistered': 'Sin alta en el IVA',
  'set.acc.vatRegisteredFrom': 'Alta en el IVA desde',
  'set.acc.vatRegisteredWhen': '¿La empresa ya estaba dada de alta en el IVA el 1 de enero de {year}?',
  'set.acc.vatRegisteredWhenHelp': 'La contabilidad de Plumme empieza en {year}. Desde la fecha de alta en el IVA, el IVA se contabiliza en ventas y compras; antes de ella, no. Si respondes «sí», la fecha se fija en el 1 de enero de {year}.',
  'set.acc.vatRegisteredPick': 'Elige una respuesta',
  'set.acc.vatRegisteredAtStart': 'Sí, dada de alta antes de {year}',
  'set.acc.vatRegisteredLater': 'No, dada de alta durante {year} o después',
  'set.acc.vatRegisteredUnknown': 'No estoy seguro',
  'set.acc.vatRegisteredFromHelp': 'La fecha en que la empresa se dio de alta en el IVA. Antes de esa fecha no se calcula IVA; a partir de ella, el IVA se contabiliza en ventas y compras.',
  'set.acc.standardVat': 'Sugerencia para nuevas líneas de venta',
  'set.acc.standardVatHelp': 'Es solo el tipo que Plumme sugiere para una nueva línea de venta. Una empresa puede usar varios tipos de IVA, y el producto o la línea de factura puede sustituir la sugerencia.',
  'set.acc.howFileVat': 'Cómo presentas el IVA',
  'set.acc.vatPeriod': 'Periodo de IVA',
  'set.acc.vatPeriodHelp': 'Con qué frecuencia presentas la declaración de IVA. La mayoría la presenta cada dos meses (6 periodos al año). Las pequeñas empresas con menos de 1 millón de NOK pueden solicitar la presentación anual. La trimestral y la mensual se usan en casos especiales.',
  'set.acc.midYearTitle': 'Empezar a mitad de año (cifras iniciales)',
  'set.acc.midYearHelp': 'Usa esto si empiezas a usar Plumme a mitad de un ejercicio fiscal. Entonces introduces las cifras iniciales (ventas, gastos e IVA en lo que va de año) del sistema anterior, para que los informes anuales y la declaración de IVA continúen con las cifras correctas.',
  'set.acc.midYear': 'Empezar a mitad de año',
  'set.acc.enterOpening': 'Introducir cifras iniciales',
  'set.acc.enterOpeningHelp': 'Abre el formulario donde introduces la fecha de transición, el IVA hasta ahora y las ventas y gastos por cuenta del sistema anterior.',
  'set.acc.ibHelp': 'El balance de apertura son los activos, el patrimonio y los pasivos que tenía la empresa al comienzo del año, es decir, el balance de cierre del año pasado. Introdúcelo cuando empieces un nuevo ejercicio fiscal en Plumme, para que el balance sea correcto desde el primer día.',
  'set.acc.viewIb': 'Ver / editar balance de apertura',
  'set.acc.viewIbHelp': 'Abre el balance de apertura que has contabilizado, donde puedes ver las líneas, editarlas o eliminar el balance.',
  'set.acc.addIb': 'Introducir balance de apertura',
  'set.acc.addIbHelp': 'Abre un asistente que te ayuda a crear el balance de apertura: confirmas la fecha de inicio e introduces las líneas del balance (débito/crédito) del año pasado.',
  'set.acc.extraAccountsHelp': 'Añade cuentas adicionales solo cuando el balance de comprobación o la exportación las necesiten.',
  'set.acc.searchPlaceholder': 'Busca en el plan de cuentas por número o nombre',
  'set.acc.searchNoHits': 'Ninguna cuenta coincide con «{query}».',
  'set.acc.addAccount': 'Añadir cuenta',
  'set.acc.addAccountHelp': 'Crea una cuenta personalizada en el plan de cuentas. Úsalo solo cuando falte una cuenta que necesitas: la mayoría de las cuentas estándar ya existen.',
  'set.acc.accountNameHelp': 'Un nombre descriptivo para la cuenta, tal como aparece en el plan de cuentas y en los informes, por ejemplo "Software/suscripción".',
  'set.acc.accountNoHelp': 'Un número de cuenta de cuatro dígitos. El primer dígito determina la clase de cuenta: 1 activos, 2 patrimonio/pasivos, 3 ingresos, 4-7 gastos, 8 finanzas e impuestos.',
  'set.acc.accountClass': 'Clase de cuenta',
  'set.acc.accountClassHelp': 'El grupo principal al que pertenece la cuenta, derivado automáticamente del primer dígito del número de cuenta. Determina si la cuenta es de activo, pasivo, ingresos o gastos.',
  'set.acc.equivalent': 'Corresponde a la cuenta',
  'set.acc.equivalentHelp': 'Vincula la cuenta personalizada con una cuenta estándar. Así Plumme sabe cómo tratar la cuenta en el cierre del ejercicio y en la declaración de impuestos, de modo que tus propias cuentas acaben correctamente en los formularios oficiales.',
  'set.acc.createAccount': 'Crear cuenta',
  'set.acc.ownAccounts': 'Cuentas personalizadas',
  'set.acc.ownAccountsHelp': 'Las cuentas que has añadido tú, además del plan de cuentas estándar. Solo estas se pueden modificar o eliminar.',
  'set.acc.noOwnAccounts': 'Aún no hay cuentas personalizadas.',
  'set.acc.removeAccount': 'Quitar cuenta',
  'set.acc.deactivated': 'desactivada',
  'set.acc.standardAccounts': 'Cuentas estándar',
  'set.acc.standardAccountsHelp': 'El plan de cuentas estándar integrado (NS 4102). Es común a todos y se usa automáticamente al contabilizar: rara vez necesitarás añadir cuentas propias.',
  'set.bank.title': 'Conciliación bancaria',
  'set.bank.help': 'La conciliación bancaria te ayuda a comprobar que las compras, las ventas y los pagos se contabilizan una sola vez y coinciden con la cuenta operativa.',
  'set.bank.activeFrom': 'Activa desde',
  'set.bank.accounts': 'Cuentas bancarias',
  'set.bank.primaryHelp': 'La cuenta principal de facturación es la cuenta predeterminada en la que pagan los clientes.',
  'set.bank.disabled': 'Desactivada',
  'set.bank.invoiceAccount': 'Cuenta de facturación',
  'set.bank.activate': 'Activar cuenta',
  'set.bank.setAsInvoice': 'Establecer como cuenta de facturación',
  'set.bank.accountNumber': 'Número de cuenta',
  'set.bank.ledgerAccount': 'Cuenta en el libro mayor',
  'set.bank.type': 'Tipo',
  'set.bank.typeOperating': 'Operativa',
  'set.bank.typeTax': 'Retenciones de impuestos',
  'set.bank.typeSavings': 'Ahorro',
  'set.bank.typePrivate': 'Privada',
  'set.bank.typeOther': 'Otra',
  'set.bank.openingBalance': 'Saldo de apertura para la conciliación',
  'set.bank.openingBalanceDate': 'Fecha del saldo de apertura',
  'set.bank.reconcileIn': 'Conciliar en Banco',
  'set.bank.mustReconcile': 'Debe conciliarse',
  'set.bank.showInPayments': 'Mostrar en «Pagado desde/a»',
  'set.bank.none': 'Aún no hay cuentas bancarias registradas.',
  'set.bank.cards': 'Tarjetas vinculadas a esta cuenta',
  'set.bank.cardsHelp': 'Los recibos suelen mostrar solo los últimos cuatro dígitos. Registra la tarjeta y Plumme reconocerá el pago sin esperar al extracto bancario. El tipo de cuenta determina si la compra es de la empresa o un gasto privado.',
  'set.bank.cardsNone': 'Esta cuenta no tiene tarjeta',
  'set.bank.cardsNoneHelp': 'Marca esta casilla, o registra las tarjetas, en cada cuenta de pago. Cuando todas las cuentas estén resueltas, Plumme sabrá qué tarjetas tiene la empresa: un recibo pagado con cualquier otra tarjeta se propondrá como un gasto privado adelantado, con una nota en el justificante.',
  'set.bank.cardPromptTitle': 'Las tarjetas deciden si es de empresa o privado',
  'set.bank.cardPromptBody': 'Plumme lee el número de tarjeta del recibo. Cuando sabemos qué tarjetas tiene la empresa, cada compra con tarjeta se resuelve automáticamente: una tarjeta conocida es una compra de la empresa; cualquier otra tarjeta, un gasto privado adelantado. Estas cuentas aún no tienen respuesta:',
  'set.bank.cardPromptSkipHelp': 'Si lo omites, la cuenta queda sin resolver y la fuente de pago de los recibos con tarjeta deberá establecerse a mano. Puedes completarlo en cualquier momento.',
  'set.bank.cardPromptFill': 'Completar ahora',
  'set.bank.cardPromptSkip': 'Guardar sin hacerlo',
  'set.bank.accountFallback': 'Cuenta bancaria',
  'set.bank.receiptDefault': 'Fuente de pago predeterminada de los justificantes',
  'set.bank.receiptDefaultSub': 'Se usa solo cuando ni la tarjeta, ni el extracto bancario ni el historial indican desde dónde se pagó la compra.',
  'set.bank.receiptDefaultLabel': 'Fuente de pago',
  'set.bank.receiptDefaultHint': 'El justificante queda listo para contabilizar, pero se marca en naranja para indicar que la fuente se preseleccionó y no se leyó del documento.',
  'set.bank.receiptDefaultNone': 'Ninguna: dejar el justificante en revisión',
  'set.bank.cardLast4': 'Últimos cuatro dígitos',
  'set.bank.cardLabel': 'Nombre de la tarjeta',
  'set.bank.cardLabelPh': 'Por ej. Visa privada',
  'set.bank.cardAdd': 'Añadir tarjeta',
  'set.bank.cardRemove': 'Quitar tarjeta',
  'set.bank.cardLast4Invalid': 'Introduce los últimos cuatro dígitos de la tarjeta.',
  'set.bank.cardDuplicate': 'Esa tarjeta ya está registrada. Dos tarjetas con los mismos cuatro dígitos no se pueden distinguir en un recibo.',
  'set.access.title': 'Acceso',
  'set.access.sub': 'Invita a un contable o socio con su propio inicio de sesión. El acceso se controla con roles.',
  'set.access.activeBusiness': 'Empresa activa',
  'set.access.active': 'Activa',
  'set.access.noBusinesses': 'Aún no hay empresas vinculadas al usuario.',
  'set.access.newBusiness': 'Nueva empresa',
  'set.access.inviteTitle': 'Invitar a un socio',
  'set.access.inviteSub': 'Invita a tu contable o a otros socios y consulta las invitaciones pendientes.',
  'set.access.noAdmin': 'No tienes el rol de administrador en la empresa seleccionada.',
  'set.access.noAdminSub': 'Solo el propietario y los administradores pueden invitar a nuevos usuarios.',
  'set.access.email': 'Correo electrónico',
  'set.access.role': 'Rol',
  'set.role.accountant': 'Contable',
  'set.role.admin': 'Administrador',
  'set.role.viewer': 'Solo lectura',
  'set.access.sendInvite': 'Enviar invitación',
  'set.access.invites': 'Invitaciones',
  'set.access.invitesSub': 'Invitaciones pendientes de la empresa activa.',
  'set.access.accept': 'Aceptar',
  'set.access.pending': 'Pendiente',
  'set.access.withdraw': 'Retirar',
  'set.access.noInvites': 'No hay invitaciones pendientes.',
  'set.access.deleteNote': 'Elimina solo la empresa seleccionada, no tu inicio de sesión ni las demás empresas.',
  'set.access.deleteBusiness': 'Eliminar esta empresa',
  'set.access.onlyOwnerDelete': 'Solo el propietario puede eliminar una empresa.',
  'set.saveChanges': 'Guardar cambios',
  'set.title': 'Ajustes',
  'set.subtitle': 'Empresa, perfil de usuario, acceso, contabilidad, banco, inversiones y datos en un solo lugar.',
  'set.tabsTitle': 'Pestañas de ajustes',
  'set.tabsHelp': 'Cada pestaña es un área de ajustes: Empresa (datos de la empresa), Perfil de usuario (tú), Acceso (quién puede hacer qué), Preferencias (notificaciones y visualización), Contabilidad (configuración y plan de cuentas), Banco, Inversiones, Datos (importación/exportación), Documentos, Integraciones y Suscripción.',
  'set.company': 'Empresa',
  'set.country': 'País',
  'set.companyName': 'Nombre de la empresa',
  'set.orgNumber': 'Número de organización',
  'set.phone': 'Teléfono',
  'set.address': 'Dirección',
  'set.zip': 'Código postal',
  'set.city': 'Localidad',
  'set.companyType': 'Tipo de empresa',
  'set.logo': 'Logotipo de la empresa',
  'set.logoAlt': 'logotipo',
  'set.logoHelp': 'Logotipo para las facturas. PNG, JPG o WebP, máx. 1 MB.',
  'set.uploadLogo': 'Subir logotipo',
  'set.previewInvoice': 'Vista previa de la factura',
  'set.deleteLogo': 'Eliminar logotipo',
  'set.inboxEmail': 'Correo de la bandeja de justificantes',
  'set.inboxEmailHelp': 'Reenvía aquí las facturas de proveedor y los recibos para que los justificantes vayan directamente a la bandeja de entrada.',
  'set.copyEmail': 'Copiar correo',
  'set.generateEmail': 'Generar una dirección nueva',
  'set.generateEmailHelp': 'Cámbiala solo si la dirección se ha filtrado o recibe spam. Las integraciones existentes deberán actualizarse.',
  'set.profile': 'Perfil de usuario',
  'set.profileSub': 'Datos asociados a tu inicio de sesión.',
  'set.loggedInEmail': 'Correo con el que has iniciado sesión',
  'set.mobile': 'Número de móvil',
  'set.saveProfile': 'Guardar perfil de usuario',
  'set.subscription': 'Suscripción',
  'set.subscriptionSub': 'La facturación la gestionan el backend y Stripe, no un plan simulado local.',
  'set.openPortal': 'Abrir portal del cliente',
  'set.current': 'Actual',
  'adv.eyebrow': 'Asesor financiero',
  'adv.beta': 'Beta',
  'adv.updating': 'Actualizando',
  'adv.lead': 'SuperPlumma analiza tu contabilidad y te asesora como un director financiero con experiencia, para {year}.',
  'adv.tab.overview': 'Resumen',
  'adv.tab.liquidity': 'Liquidez y riesgos',
  'adv.tab.sales': 'Ventas y rentabilidad',
  'adv.tab.costs': 'Gastos',
  'adv.sales.title': 'Ventas y rentabilidad',
  'adv.sales.sub': 'Facturas de venta contabilizadas de {year}',
  'adv.sales.help': 'Todas las cifras se calculan a partir de las facturas de venta contabilizadas del año seleccionado, comparadas con la misma cifra del año anterior. Se excluyen los borradores, las notas de crédito y los presupuestos.',
  'adv.sales.emptyTitle': 'Aún no hay facturas de venta contabilizadas',
  'adv.sales.emptyText': 'Cuando hayas contabilizado ventas, calcularé la rentabilidad por cliente, el plazo de pago, el nivel de descuentos y qué productos están creciendo.',
  'adv.sales.periodYear': 'en {year}',
  'adv.sales.periodVsPrev': 'frente a {year}',
  'adv.sales.invoiceCount': '{count} facturas',
  'adv.sales.customerCount': '{count} clientes',
  'adv.sales.recurringCount': '{count} con facturación recurrente',
  'adv.sales.days': '{days} días',
  'adv.sales.noPayments': 'Aún no hay pagos',
  'adv.sales.kpi.revenue': 'Ingresos',
  'adv.sales.kpi.growth': 'Crecimiento de ingresos',
  'adv.sales.kpi.growthHelp': 'Variación de las ventas contabilizadas respecto al mismo periodo del año pasado. Se muestra «—» cuando no hay cifras del año anterior con las que comparar.',
  'adv.sales.kpi.avgInvoice': 'Factura media',
  'adv.sales.kpi.discount': 'Descuento medio',
  'adv.sales.kpi.discountHelp': 'Descuento total dividido por lo que habrían valido las facturas sin él. Si esta cifra sube sin que suba el volumen, estás regalando margen sin contrapartida.',
  'adv.sales.kpi.paymentDays': 'Plazo de pago',
  'adv.sales.kpi.paymentDaysHelp': 'Media de días entre la fecha de factura y un pago registrado. Solo cuentan las facturas pagadas: las impagadas no inflan la media.',
  'adv.sales.kpi.repeat': 'Tasa de recompra',
  'adv.sales.kpi.repeatHelp': 'Proporción de clientes con más de una factura este año. Una tasa de recompra alta da unos ingresos más predecibles que las mismas ventas repartidas entre clientes puntuales.',
  'adv.sales.kpi.concentration': 'Concentración de clientes',
  'adv.sales.kpi.concentrationHelp': 'Proporción de los ingresos que proviene de tu mayor cliente. Por encima del 40 %, un solo cliente puede hundir por sí solo el negocio.',
  'adv.sales.kpi.recurring': 'Ingresos recurrentes',
  'adv.sales.kpi.recurringHelp': 'Proporción de los ingresos procedente de facturas con facturación recurrente o de una suscripción.',
  'adv.sales.customers': 'Rentabilidad por cliente',
  'adv.sales.customersSub': 'Ingresos, plazo de pago y nivel de descuento por cliente',
  'adv.sales.customersHelp': 'Los clientes se ordenan por ingresos en el año seleccionado. La tendencia compara con el año pasado: un cliente nuevo sin cifras del año anterior recibe su propia marca en lugar de una flecha.',
  'adv.sales.col.customer': 'Cliente',
  'adv.sales.col.revenue': 'Ingresos',
  'adv.sales.col.grossProfit': 'Margen bruto',
  'adv.sales.col.paymentSpeed': 'Plazo de pago',
  'adv.sales.col.discount': 'Descuento',
  'adv.sales.col.jobs': 'Facturas',
  'adv.sales.col.trend': 'Tendencia',
  'adv.sales.partialProfit': 'No calculado',
  'adv.sales.trendNew': 'Cliente nuevo este año',
  'adv.sales.showAll': 'Mostrar los {count} clientes',
  'adv.sales.showFewer': 'Mostrar menos',
  'adv.sales.profitNote': 'El margen bruto se muestra cuando todas las líneas de factura del cliente tienen un precio de coste registrado. Las facturas antiguas y las líneas sin precio de coste muestran «No calculado».',
  'adv.sales.products': 'Productos y servicios',
  'adv.sales.productsSub': 'Ingresos por producto y qué crece o cae',
  'adv.sales.productsHelp': 'Los productos provienen de las líneas de factura. Las líneas sin nombre de producto se agrupan bajo "Sin nombre de producto". El crecimiento y la caída se miden frente al mismo producto del año pasado.',
  'adv.sales.topRevenue': 'Mayores ingresos',
  'adv.sales.growing': 'Mayor crecimiento',
  'adv.sales.falling': 'Mayor caída',
  'adv.sales.noComparison': 'No hay cifras del año anterior con las que comparar',
  'adv.sales.verdictTag': 'Ventas y rentabilidad ahora mismo',
  'adv.sales.verdict.concentration': '{name} representa el {pct} % de las ventas facturadas de {revenue}. Es el mayor riesgo de tus ventas ahora mismo: si ese cliente se va, la mayor parte de los ingresos se va con él.',
  'adv.sales.verdict.slowPayers': 'Las ventas en sí se ven bien, pero {count} cliente(s) pagan despacio: el más lento tarda {days} días. El dinero ya está ganado; simplemente está fuera más tiempo del necesario.',
  'adv.sales.verdict.discounts': 'Das de media un {pct} % de descuento, {amount} en total este año. Es dinero de ventas que ya has cerrado: conviene comprobar que el descuento realmente aporta volumen.',
  'adv.sales.verdict.growing': 'Las ventas han subido un {pct} % respecto al año pasado y ahora son de {revenue}. Nada en las cifras de ventas requiere actuar ahora: lo principal es mantener el ritmo.',
  'adv.sales.verdict.shrinking': 'Las ventas han bajado un {pct} % respecto al año pasado y son de {revenue}. Es la señal más clara en tus cifras de ventas ahora.',
  'adv.sales.verdict.steady': 'Las ventas son de {revenue} repartidas en {count} facturas. No veo señales de alerta en las cifras de ventas: las acciones de abajo son oportunidades, no problemas.',
  'adv.sales.moves.title': 'Esto es lo que haría primero',
  'adv.sales.moves.sub': 'Acciones priorizadas, ordenadas por efecto',
  'adv.sales.moves.help': 'Cada acción tiene detrás una cifra de tus propias facturas. El tipo de efecto indica qué clase de magnitud es la cifra (días, coronas o proporción) y nunca deben sumarse entre sí.',
  'adv.sales.move.chaseSlowPayers.title': 'Reclama a los clientes que pagan más tarde',
  'adv.sales.move.chaseSlowPayers.text': '{count} cliente(s) pagan más despacio que el resto. {name} tarda {days} días de media.',
});
